import { CpsSearchExportRequest } from '@cs-cms/types';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { mutateSearchKeys } from '../../mutationKeys/search';

export function useTriggerExportToCsv(): UseMutationResult<
  void,
  unknown,
  {
    dto: CpsSearchExportRequest;
  }
> {
  const servicesCtx = useContext(ServicesContext);

  const triggerExportToCsv = (data: { dto: CpsSearchExportRequest }) => {
    if (servicesCtx?.searchService) {
      return servicesCtx.searchService.triggerExportToCsv(data.dto);
    }
    throw new Error('Services context not initialized');
  };

  return useMutation({
    mutationKey: mutateSearchKeys.triggerExportToCsv,
    mutationFn: triggerExportToCsv
  });
}
